import React from 'react';
import { Label } from 'semantic-ui-react'

const PgaSectionLabels = ({heading="", label, children}) => {
    return ( 
        <div className='AOC-container'>
            {children}
            {heading && <center className='ml-auto'> <h5>{heading}</h5></center>}
            <Label className="PG-label">{label}</Label>
        </div>
     );
}
 
export default PgaSectionLabels;